import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <FAQSection />
        <FeaturesSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <TopicsSection />
        <AppSection />
        <MediaSection />
        <ContactSection />
        <UpdatesSection />
        <CarouselSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}